const $win = $(window);
const $header = $('.header');
const isScrolled = 'is-scrolled';

$win.on('load scroll resize', function() {

	if ($win.scrollTop() > 0) {
		$header.addClass(isScrolled)
	} else {
		$header.removeClass(isScrolled)
	}
})
